<template>
  <div class="ll-btn-groups-item__container">
    <div
      v-click-outside="$_popupClose"
      class="ll-btn-groups-item"
      :class="{active:$_isBtnSelected(btn),'small-size':smallSize,'normal-size':normalSize}"
      @click="$_btnClick(btn)"
    >
      <WsText001 h4>
        {{ $t(btn.textLabel )}}<span v-if="$_isBtnSelected(btn) && btn.subList">-{{ _subListText }}</span>
      </WsText001>
    </div>
    <div
      v-if="btn.subList"
      class="ll-btn-groups-item__popup"
      :class="{active:popupActive}"
    >
      <div
        v-for="(item,itemIndex) in btn.subList"
        :key="itemIndex"
        class="ll-btn-groups-item__popup-item"
        :class="{active:$_isBtnSelected(item)}"
        @click="$_popupBtnclick(item)"
      >
        {{ $t(item.textLabel) }}
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "LlBtnGroupsItem",
  directives: {
    ClickOutside,
  },

  props: {
    normalSize: {
      type: Boolean,
      default: false,
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    smallSize: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    btn: {
      type: Object,
      default() {
        return {
          value: "notGood",
          textLabel: this.$t("不合規"),
          subList: [
            {
              score: 23,
              value: "major",
              textLabel: 'Major(主要缺失)',
            },
            {
              score: 22,
              value: "minor",
              textLabel: 'Minor(次要缺失)',
            },
            {
              score: 21,
              value: "OFI",
              textLabel: 'OFI(待改善)',
            },
          ],
        };
      },
    },
  },

  data: () => ({
    textValue: "",
    popupActive: false,
  }),

  computed: {
    _subListText() {
      return this.textValue;
    },
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.$_setTextValue();
      },
    },
  },

  mounted() {
    this.$_setTextValue();
    this.$_isBtnSelected(this.btn);
  },

  methods: {
    $_setTextValue() {
      if (!this.btn.subList) return;
      this.btn.subList.forEach((item) => {
        if (item.score === parseInt(this.value)) {
          this.textValue = item.value;
        } else return;
      });
    },
    $_btnClick(btn) {
      if (btn.subList) {
        this.popupActive = !this.popupActive;
      } else {
        this.$emit("input", this.btn.score);
      }
    },
    $_popupClose() {
      this.popupActive = false;
    },
    $_popupBtnclick(item) {
      this.textValue = item.value;
      this.$emit("input", item.score);
    },
    $_isBtnSelected(btn) {
      let btnValue = btn.score;
      if (btn.subList) {
        for (let i = 0; i < btn.subList.length; i++) {
          if (btn.subList[i].score === parseInt(this.value)) {
            return true;
          }
        }
      }
      if (parseInt(this.value) === btnValue) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-btn-groups-item";
</style>